import UniversalInput from 'components/global/UniversalInput';
import { handleSubmitFinancialsEdit } from 'components/views/FounderVault/_helpers/founderVault.events';
import { fetchAndSetFinancialData } from 'components/views/FounderVault/_helpers/founderVault.resolvers';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';

const FounderFinancials = () => {
  useEffectAsync(fetchAndSetFinancialData);

  return (
    <>
      <Row className="mt-24">
        <Col lg={6} className="mb-24">
          <div className="d-flex mb-8 align-items-center justify-content-between">
            <div className="text-white">Post Money Valuation</div>
            <Button
              variant="outline-info d-flex align-items-center"
              size="sm"
              className="bg-transparent border-0 text-muted"
            >
              <Image src="/images/ai-icon.svg" className="me-8 object-fit-contain" width={16} height={16} />
              Estimate My Valuation with AI Coming Soon
            </Button>
          </div>
          <UniversalInput
            type="money"
            name="postMoneyValuation"
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            type="money"
            name="amountPreviouslyRaised"
            label="Amount Previously Raised"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="arr"
            label="Annual Recurring Revenue"
            type="money"
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="mrr"
            label="Monthly Recurring Revenue"
            type="money"
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="otherRevenue"
            label="Other Revenue"
            type="money"
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="cashOnHand"
            label="Cash on Hand"
            type="money"
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="liabilities"
            type="money"
            label="Current Liabilities"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="investments"
            type="money"
            label="Investments Held by Company"
            required
          />
        </Col>
        <Col lg={6} className="mb-24">
          <UniversalInput
            name="otherAssets"
            type="money"
            label="Other Assets Owned by Company"
            required
          />
        </Col>
      </Row>
      <Row className="mt-24">
        <Col>
          <div className="d-flex justify-content-between">
            <Button
              className="fw-600 px-24 py-8"
              onClick={handleSubmitFinancialsEdit}
              disabled={$view.value.isFormSaving}
            >
              Save Changes
            </Button>
            {/* TODO: Add back Once we have the stripe and plaid integration */}
            {/* <div>
              <Button
                className="fw-600 px-24 py-8 text-gradient-warning-primary me-32"
                onClick={handleSubmitFinancialsEdit}
                disabled={$view.value.isFormSaving}
                size="sm"
              >
                Sync with Stripe
              </Button>
              <Button
                className="fw-600 px-24 py-8 bg-white text-gradient-secondary-primary"
                onClick={handleSubmitFinancialsEdit}
                disabled={$view.value.isLoading}
                size="sm"
              >
                Sync with Plaid
              </Button>
            </div> */}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default FounderFinancials;
